import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BannerService } from '../../services/banner.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  imagen: string;
  constructor(private banner: BannerService) { }

  ngOnInit() { this.banner.change.subscribe(img => this.imagen = img); }
}
